module.exports = __webpack_public_path__ + "img/salidaRuta.69e1c8b6.svg";